import React from "react";
import "./List.scss";
import Card from "../Card/Card";
import useFetch from "../../hooks/useFetch";

const List = ({ subCats, maxPrice, sort, catId, flov }) => {
  let query = `/products?populate=*`;

  // Always filter by main category
  query += `&[filters][categories][id][$eq]=${catId}`;

  // Add sub-category filters if selected
  if (subCats?.length > 0) {
    const subCatFilters = subCats
      .map((id) => `&[filters][sub_categories][id][$in]=${id}`)
      .join("");
    query += subCatFilters;
  }

  // Add flavor filters if selected
  if (flov.length > 0) {
    const flovFilters = flov
      .map((id) => `&[filters][flavors][id][$in]=${id}`)
      .join("");
    query += flovFilters;
  }

  // Always apply max price
  query += `&[filters][price][$lte]=${maxPrice}`;

  // Sorting if applicable
  if (sort) {
    query += `&sort=price:${sort}`;
  }

  const { data, loading, error } = useFetch(query);

 

  // Custom sorting: most_selling_product first
  const sortedData = Array.isArray(data)
    ? [...data]
        .filter((item) => item.attributes.most_selling_product === true)
        .concat(
          [...data].filter(
            (item) => item.attributes.most_selling_product !== true
          )
        )
    : [];

    
    const manualSortedData = sortedData.sort((a, b) => {
      const aVal = a?.attributes?.manual_sorting;
      const bVal = b?.attributes?.manual_sorting;

      if (!aVal && !bVal) return 0;
      if (!aVal) return 1;
      if (!bVal) return -1;

      return aVal.toLowerCase().localeCompare(bVal.toLowerCase());
    });
    

  const hideOutofStock = Array.isArray(sortedData)
    ? sortedData.filter((item) => item.attributes.outofstock !== true)
    : [];




  return (
    <div className="list">
      {loading ? (
        <div className="cen_wrp">
          <p>Loading...</p>
        </div>
      ) : error ? (
        <div className="cen_wrp">
          <p>Please try again later.</p>
        </div>
      ) : Array.isArray(data) && data.length === 0 ? (
        <div className="cen_wrp">
          <p>
            No products found for the selected filters. <br /> Please try
            adjusting your filters or explore other categories.
          </p>
        </div>
      ) : Array.isArray(data) ? (
        manualSortedData.map((item) => <Card item={item} key={item.id} />)
      ) : null}
    </div>
  );
};

export default List;
